import React, { useEffect, useState } from 'react';
import Project from './Project';
import ProjectData from './ProjectData';
// import { Link } from 'react-router-dom';

const ProjectMap = () => {
  const [visibleProjects, setVisibleProjects] = useState([]);

  useEffect(() => {
    const indices = ProjectData.map((_, index) => index);
    const showProjects = (index) => {
      if (index < indices.length) {
        setVisibleProjects((prev) => [...prev, indices[index]]);
        setTimeout(() => showProjects(index + 1), 400); // 400ms delay
      }
    };
    showProjects(0); // Start showing projects
  }, []);

  return (
    <div className="app_portfolio">
      {ProjectData.map((project, index) => {
        const isVisible = visibleProjects.includes(index);
        const className = `project ${isVisible ? 'visible' : ''} fade-in fade-in-delay-${index + 1}`;
        
        return (
          <div key={index} className={className}>
           
            <Project
              image={project.image}
              alt={project.alt}
              title={project.title}
              description={project.description}
              tools={project.tools}
              link={`/case-study/${project.id}`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ProjectMap;
